import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREY,
    codeProp: 'ruleUserCode',
    listUrl: '/BdLogicList',
    mapProp: 'ruleMap',
    name: '程序能力',
    ownerIdProp: 'bdId',
    ownerTextProp: 'bdName',
    ownerType: 'BD',
    textProp: 'ruleTitle',
    type: 'BDLOGIC',
}
